var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"4194.352 1931.352 15.297 15.297"}},[_c('g',{attrs:{"data-name":"Groupe 264"}},[_c('path',{attrs:{"d":"M4195.059 1931.351l-.708.708 14.59 14.59.707-.708z"}}),_c('path',{attrs:{"d":"M4208.941 1931.351l-14.59 14.59.708.707 14.59-14.59z"}})])])};var toString = function () {return "/builds/agoulay/GUI-drivers/src/assets/svg/icon-close.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-close.svg
// module id = 5hVN
// module chunks = 2